import { AxiosError } from 'axios';

const isNetworkError = (error: unknown): boolean => !(error as AxiosError)?.response;

export default isNetworkError;
